module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis strony (dla: google, facebook)",
      "error": _vm.errors[_vm.addLanguageSuffix('meta_description')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('meta_description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('meta_description'), $$v)
      },
      expression: "form[addLanguageSuffix('meta_description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup",
      "error": _vm.errors['popup']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "lessDetails": true,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")]), _vm._v(" "), _c('label', [_vm._v("\n                            Ukryj\n                            "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86bc2724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pages/PageForm.vue
// module id = 784
// module chunks = 0